import { createAction } from 'redux-actions'
import UserService from '../../services/UserService'
import { listenForPoll } from './poll'
import { listenForResults } from './results'
import types from './types'

const service = new UserService()

export function listenForPolls() {
	return (dispatch) => {
		service.listenForPollIds((pollId) => {
			dispatch(listenForPoll(pollId))
			dispatch(listenForResults(pollId))
		})
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/user.js